import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по CTA в балуне карты (например, «Смотреть проект»), в т.ч. через делегирование с HTML балуна.
 * cta - Call to Action
 */
export function trackMapBalloonCtaClick(newbuildingId: string): void {
  ca('eventSite', {
    action: 'click',
    category: 'Promo',
    label: 'project_map_balloon_cta',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: [
            {
              id: newbuildingId,
              offerType: 'newbuilding_id',
            },
          ],
        },
      }),
    ],
  });
}
